import { h } from 'preact';
import Image from 'utils/image';

const Swatches = ({
  swatchesToRender,
  clickHandler,
  currentStyle,
  label,
  monogramTextDetails,
}) => {
  if (!swatchesToRender.length) return null;

  const renderedSwatches = swatchesToRender.map((block) => (
    <div
      // eslint-disable-next-line max-len
      className={`border border-1 hover:border-gray-900 text-center h-10 transition-all cursor-pointer ${
        currentStyle === block.title ? 'border-gray-900' : 'border-gray-400'
      }`}
      key={block.title}
      onClick={() => clickHandler(block)}
    >
      <Image
        classes="h-full w-full object-contain"
        src={block.image}
        alt={block.title}
      />
    </div>
  ));

  return (
    <div className="border border-1 border-x-0 border-t-0 border-gray-300 pb-5 mb-5">
      <div className="body-3 mb-2.5">
        {label}: <span className="font-medium">{currentStyle}</span>
      </div>
      <div className="grid grid-cols-5 gap-2 mb-3.5">{renderedSwatches}</div>
      {monogramTextDetails && (
        <p className="body-3 text-color-subdued">{monogramTextDetails}</p>
      )}
    </div>
  );
};

export default Swatches;
